import { IV3D } from '@/Interfaces/v3d';
import { $ } from '@/Engine/state';
import { Object3D } from 'three';
import { getFileNameByBlenderName } from '@/Constants/glb';
import { v3dMesh } from '@/Interfaces/common';

declare let v3d: IV3D;

export async function uploadModel(blenderName?: string): Promise<Promise<Object3D[] | Object3D> | undefined> {
    const fileName = getFileNameByBlenderName(blenderName);
    if (!fileName || !blenderName) return;
    if (!$.isUpdateLoadModel) return;
    $.isUpdateLoadModel = false;
    //проверка: была ли модель загружена ранее?
    if ($.modelCache?.isHas(blenderName)) {
        $.isUpdateLoadModel = true;
        return $.modelCache?.getModelByName(blenderName);
    }

    const dataURL = await $.loader.getAsync(fileName)
        .catch((err) => {
            console.error(err);
            $.isUpdateLoadModel = true;
        });
    const model = await loadModel(dataURL as string, blenderName)
        .catch((err) => {
            console.error(err);
            $.isUpdateLoadModel = true;
        });
    $.modelCache?.setModalCache(blenderName, model as v3dMesh);
    $.isUpdateLoadModel = true;
    return model;
}

export const loadModel = function(url: string, blenderName?: string): Promise<Object3D> {
    return new Promise((resolve, reject) => {
        if (!$.gltfLoader) {
            console.log('no gltfLoader');
            return;
        }
        $.gltfLoader.load(url, function(gltf) {
            gltf.scene.traverse((obj: Object3D) => {
                if (obj.name === blenderName) {
                    resolve(obj);
                }
            });
            reject();
        });
    });
};
